import {userConstants} from '../../_constants';

export function listMyFavorite(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_MY_FAVORITE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_MY_FAVORITE_SUCCESS:
      return {
        loading: false,
        dataMyFavorite: action.data,
        //...action.data,
      };
    case userConstants.GET_MY_FAVORITE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
